import { default as indexfJhGZOiaLXMeta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/cookies-policy/index.vue?macro=true";
import { default as indexI1hpmR7e6SMeta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/directory/index.vue?macro=true";
import { default as index7FSnsq0u5MMeta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/directory/map/index.vue?macro=true";
import { default as indexC8kreAjEDGMeta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/index.vue?macro=true";
import { default as index7U8tJATHncMeta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/privacy-policy/index.vue?macro=true";
import { default as indexw4ajmW98HqMeta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/profile/index.vue?macro=true";
import { default as indexMrtuyDasKvMeta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/property/[id]/index.vue?macro=true";
import { default as index2rQYZdTjv4Meta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/terms/index.vue?macro=true";
import { default as emailIjQ2c7zqVjMeta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/email.vue?macro=true";
import { default as googleVbZTkPPf2fMeta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/google.vue?macro=true";
import { default as previewKuxmJ8MhgZMeta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/preview.vue?macro=true";
import { default as component_45stubvKfDLcqDo7Meta } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.5.1_@types+node@25.9.1_db0@0.2.4_eslint@9.14.0_jiti@2.4.2__iore_gw4d4udegl3jeabtn5rtub3y6a/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubvKfDLcqDo7 } from "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.5.1_@types+node@25.9.1_db0@0.2.4_eslint@9.14.0_jiti@2.4.2__iore_gw4d4udegl3jeabtn5rtub3y6a/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "cookies-policy___en",
    path: "/cookies-policy",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/cookies-policy/index.vue")
  },
  {
    name: "cookies-policy___de",
    path: "/de/cookies-policy",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/cookies-policy/index.vue")
  },
  {
    name: "cookies-policy___ru",
    path: "/ru/cookies-policy",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/cookies-policy/index.vue")
  },
  {
    name: "cookies-policy___es",
    path: "/es/cookies-policy",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/cookies-policy/index.vue")
  },
  {
    name: "directory___en",
    path: "/directory",
    meta: indexI1hpmR7e6SMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/directory/index.vue")
  },
  {
    name: "directory___de",
    path: "/de/directory",
    meta: indexI1hpmR7e6SMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/directory/index.vue")
  },
  {
    name: "directory___ru",
    path: "/ru/directory",
    meta: indexI1hpmR7e6SMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/directory/index.vue")
  },
  {
    name: "directory___es",
    path: "/es/directory",
    meta: indexI1hpmR7e6SMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/directory/index.vue")
  },
  {
    name: "directory-map___en",
    path: "/directory/map",
    meta: index7FSnsq0u5MMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/directory/map/index.vue")
  },
  {
    name: "directory-map___de",
    path: "/de/directory/map",
    meta: index7FSnsq0u5MMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/directory/map/index.vue")
  },
  {
    name: "directory-map___ru",
    path: "/ru/directory/map",
    meta: index7FSnsq0u5MMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/directory/map/index.vue")
  },
  {
    name: "directory-map___es",
    path: "/es/directory/map",
    meta: index7FSnsq0u5MMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/directory/map/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexC8kreAjEDGMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexC8kreAjEDGMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexC8kreAjEDGMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexC8kreAjEDGMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/index.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___de",
    path: "/de/privacy-policy",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___ru",
    path: "/ru/privacy-policy",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/privacy-policy/index.vue")
  },
  {
    name: "profile___en",
    path: "/profile",
    meta: indexw4ajmW98HqMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/profile/index.vue")
  },
  {
    name: "profile___de",
    path: "/de/profile",
    meta: indexw4ajmW98HqMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/profile/index.vue")
  },
  {
    name: "profile___ru",
    path: "/ru/profile",
    meta: indexw4ajmW98HqMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/profile/index.vue")
  },
  {
    name: "profile___es",
    path: "/es/profile",
    meta: indexw4ajmW98HqMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/profile/index.vue")
  },
  {
    name: "property-id___en",
    path: "/property/:id()",
    meta: indexMrtuyDasKvMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/property/[id]/index.vue")
  },
  {
    name: "property-id___de",
    path: "/de/property/:id()",
    meta: indexMrtuyDasKvMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/property/[id]/index.vue")
  },
  {
    name: "property-id___ru",
    path: "/ru/property/:id()",
    meta: indexMrtuyDasKvMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/property/[id]/index.vue")
  },
  {
    name: "property-id___es",
    path: "/es/property/:id()",
    meta: indexMrtuyDasKvMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/property/[id]/index.vue")
  },
  {
    name: "terms___en",
    path: "/terms",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/terms/index.vue")
  },
  {
    name: "terms___de",
    path: "/de/terms",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/terms/index.vue")
  },
  {
    name: "terms___ru",
    path: "/ru/terms",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/terms/index.vue")
  },
  {
    name: "terms___es",
    path: "/es/terms",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/terms/index.vue")
  },
  {
    name: "third-party-auth-email___en",
    path: "/third-party-auth/email",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/email.vue")
  },
  {
    name: "third-party-auth-email___de",
    path: "/de/third-party-auth/email",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/email.vue")
  },
  {
    name: "third-party-auth-email___ru",
    path: "/ru/third-party-auth/email",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/email.vue")
  },
  {
    name: "third-party-auth-email___es",
    path: "/es/third-party-auth/email",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/email.vue")
  },
  {
    name: "third-party-auth-google___en",
    path: "/third-party-auth/google",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/google.vue")
  },
  {
    name: "third-party-auth-google___de",
    path: "/de/third-party-auth/google",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/google.vue")
  },
  {
    name: "third-party-auth-google___ru",
    path: "/ru/third-party-auth/google",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/google.vue")
  },
  {
    name: "third-party-auth-google___es",
    path: "/es/third-party-auth/google",
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/google.vue")
  },
  {
    name: "third-party-auth-preview___en",
    path: "/third-party-auth/preview",
    meta: previewKuxmJ8MhgZMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/preview.vue")
  },
  {
    name: "third-party-auth-preview___de",
    path: "/de/third-party-auth/preview",
    meta: previewKuxmJ8MhgZMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/preview.vue")
  },
  {
    name: "third-party-auth-preview___ru",
    path: "/ru/third-party-auth/preview",
    meta: previewKuxmJ8MhgZMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/preview.vue")
  },
  {
    name: "third-party-auth-preview___es",
    path: "/es/third-party-auth/preview",
    meta: previewKuxmJ8MhgZMeta || {},
    component: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/pages/third-party-auth/preview.vue")
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/faq",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/de/faq",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/ru/faq",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/es/faq",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/search",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/de/search",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/ru/search",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/es/search",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/search/:pathMatch(.*)",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/de/search/:pathMatch(.*)",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/ru/search/:pathMatch(.*)",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/es/search/:pathMatch(.*)",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/index-sitemap.xml",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/en-US-sitemap.xml",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/de-DE-sitemap.xml",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/ru-RU-sitemap.xml",
    component: component_45stubvKfDLcqDo7
  },
  {
    name: component_45stubvKfDLcqDo7Meta?.name,
    path: "/es-ES-sitemap.xml",
    component: component_45stubvKfDLcqDo7
  }
]